export default "__VITE_ASSET__ChH9DNZG__"